/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Telegram_Tile_MobileInputs */

const tr_landing_telegram_tile_mobile = /** @type {(inputs: Landing_Telegram_Tile_MobileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mobil uygulama (iOS & Android · yakında): aynı akış.`)
};

const en_landing_telegram_tile_mobile = /** @type {(inputs: Landing_Telegram_Tile_MobileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mobile app (iOS & Android · coming soon): the same flow.`)
};

const de_landing_telegram_tile_mobile = /** @type {(inputs: Landing_Telegram_Tile_MobileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mobile App (iOS & Android · bald verfügbar): derselbe Ablauf.`)
};

const ru_landing_telegram_tile_mobile = /** @type {(inputs: Landing_Telegram_Tile_MobileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Мобильное приложение (iOS и Android · скоро): тот же процесс.`)
};

/**
* | output |
* | --- |
* | "Mobile app (iOS & Android · coming soon): the same flow." |
*
* @param {Landing_Telegram_Tile_MobileInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_telegram_tile_mobile = /** @type {((inputs?: Landing_Telegram_Tile_MobileInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Telegram_Tile_MobileInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_telegram_tile_mobile(inputs)
	if (locale === "de") return de_landing_telegram_tile_mobile(inputs)
	if (locale === "ru") return ru_landing_telegram_tile_mobile(inputs)
	return tr_landing_telegram_tile_mobile(inputs)
});